import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { IBreadcrumbItem } from 'src/components/Breadcrumbs/Breadcrumbs';

export const useGetParentAccountsRedirectUrl = (): IBreadcrumbItem => {
  const {
    enterpriseData: { isInternalAdminUser },
  } = useAuth();

  const internalAdminParentAccountsUrlObject = {
    label: 'Parent accounts',
    href: '/groupadmin/parents',
    useRouterLink: false,
  };
  const parentAdminParentAccountsUrlObject = {
    label: 'Parent accounts',
    href: '/corporate/enterprise/parents/accounts',
    useRouterLink: true,
  };

  return isInternalAdminUser
    ? internalAdminParentAccountsUrlObject
    : parentAdminParentAccountsUrlObject;
};
